import { observer } from "mobx-react";
import { useEffect } from "react";
import { CompanyUserInterface, companyUserStore, languageStore, navigationStore, toastStore, userStore } from "stores";
import useUserRoleDepartmentByParams from "../useUserRoleDepartmentByParams";
import _ from 'lodash';
import TableHeader from "components/Table/TableHeader";
import TableDetails from "components/AdminPage/TableDetails";
import AddUserModal from "components/AddUserModal";
import { useParams } from "react-router";

const Users = observer(() => {
    const department = useUserRoleDepartmentByParams();
    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        const me = userStore.signedInUser;
        companyUserStore.getUsers(me.company.id);

    }, []);

    if (!department) return null;

    const onAddUserToDepartment = async (userId: string) => {
        const user = _.find(companyUserStore.users, u => u.id === userId);
        if (!user || !department) return;

        const departments = [...user.departments, department];
        await companyUserStore.setDepartments(user.companyId, user.id, departments);

        toastStore.addDefaultSuccessfulSaveToast();
    }

    const onRemoveUserFromDepartment = async (user: CompanyUserInterface) => {
        if (!window.confirm(`${languageStore.get('areYouSureYouWantToDelete')}?`)) return;

        const departments = _.filter(user.departments, (d) => d.id !== id);
        await companyUserStore.setDepartments(user.companyId, user.id, departments);

        toastStore.addDefaultSuccessfulSaveToast();
    }


    const columns = [
        {
            Header: <TableHeader value={languageStore.get('name')} />,
            id: 'fullName',
            accessor: (d: CompanyUserInterface) => {
                return (
                    <span>
                        {d.fullName}
                        {
                            d.disabled &&
                            <span className='font-semibold inline text-red text-xs'><br />{languageStore.get('inactive')}</span>
                        }
                    </span>
                )
            }
        },
        {
            Header: <TableHeader value={languageStore.get('email')} />,
            accessor: 'email'
        },
        {
            Header: null,
            id: 'actions',
            width: 180,
            accessor: (d: CompanyUserInterface) => {
                return (
                    <>
                        <button
                            className='ml-2 px-2 py-1 text-xs text-red rounded bg-red-lightest hover:bg-red-lighter'
                            onClick={(e) => onRemoveUserFromDepartment(d)}>
                            {languageStore.get('remove')}
                        </button>
                        <button
                            className='ml-6 px-2 py-1 text-xs text-grey-darkest rounded bg-grey-light hover:bg-red-lighter'
                            onClick={(e) => navigationStore.push(`/admin/users/${d.id}`)}>
                            {languageStore.get('goTo')} &rarr;
                        </button>
                    </>
                )
            }
        }
    ]

    const data = _.filter(companyUserStore.users, (u) => _.some(u.departments, (d) => d.id === department.id));

    const skipUsers = _.filter(companyUserStore.users, (u) => {
        return (!_.some(u.locations, (l) => l.id === department.locationId)
            || _.some(u.departments, (d) => d.id === department.id))
    });

    return (
        <TableDetails
            actions={
                <AddUserModal
                    companyId={userStore.signedInUser.company.id!}
                    onSubmit={onAddUserToDepartment}
                    skipUserIds={skipUsers.map((d) => d.id)}
                />
            }
            data={_.orderBy(data, 'fullName')}
            columns={columns}
            filterBy={['fullName']}
        />
    )
})

export default Users;